import { toast } from 'react-toastify';

export const showNotification = (status: string, message: string) => {
  if (status === 'success') toast.success(message);
  else toast.error(message ?? 'Error');
};
